// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3551":"SuccessStory","5759":"pages-public-Video"}[chunkId] + "." + {"3551":"206032ed606733aae72e","5759":"206032ed606733aae72e"}[chunkId] + ".css";
};